module.exports = __webpack_public_path__ + "static/img/7.ff7539e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/7.png
// module id = 12Qd
// module chunks = 0